import React, { useCallback } from "react";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import {
  ILifeChoiceTabs,
} from "types/context/lifeChoicePage";
import Overview from "./Overview/index";
import Career from "./Career";
import Academy from "./Academy";
import Apply from "./Apply";

const Content = () => {
  const { activeTab } = useLifeChoicePageContext();

  const renderTab = useCallback(
    (tab) => {
      switch (tab) {
        case ILifeChoiceTabs.OVERVIEW:
          return <Overview />;
        case ILifeChoiceTabs.CAREER:
          return <Career />;
        case ILifeChoiceTabs.ACADEMY:
          return <Academy />;
        case ILifeChoiceTabs.APPLY:
          return <Apply />;
      }
    },
    [activeTab]
  );

  return <main className="pt-8 lg:pt-20">{renderTab(activeTab)}</main>;
};

export default Content;
